import React, { useState } from "react";
import { NaturalPersonForm, QuestionaryForm } from "@/components";
import { Tabs, TabList, Tab, TabPanel } from "react-tabs";
import BankCryptoManagement from "./BankSettingsRedo";
import BusinessInfoFormNEW from "@/components/AccountForms/BusinessInfoNEW";
import { getUser } from "@/utils/localStorage";
import { checkPermissionByKeyAndValue, isBitramp } from "@/utils/utils";

interface ClientSettingsProps {
  client_settings_id: number;
}

const ClientSettings: React.FC<ClientSettingsProps> = () => {


  const user = getUser();

  const canAccessBusinessInfo =
    checkPermissionByKeyAndValue(
      user?.permissions || [],
      "view",
      "businessinfo"
    ) || user?.is_superuser;

  const canAccessNaturalPerson =
    checkPermissionByKeyAndValue(
      user?.permissions || [],
      "view",
      "individualinfo"
    ) || user?.is_superuser;

  const canAccessQuestionary =
    checkPermissionByKeyAndValue(
      user?.permissions || [],
      "view",
      "financialinfo"
    ) || user?.is_superuser;

  const initialTabIndex = canAccessBusinessInfo
    ? 0
    : canAccessNaturalPerson
    ? 1
    : canAccessQuestionary
    ? 2
    : 0; // fallback, dacă nu are acces la niciunul

  const [activeTab, setActiveTab] = useState(initialTabIndex);


  return (
    <div className="settings">
      <div className="settings__right">
        <div className="settings__right--flex"></div>
        <div>
          <Tabs selectedIndex={activeTab} onSelect={(idx) => setActiveTab(idx)}>
            <TabList className="flex gap-2 justify-between rounded-t-[0.645rem]">
              <Tab
                disabled={!canAccessBusinessInfo}
                className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                  isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                } flex justify-center items-center mb-2`}
                selectedClassName={`${
                  isBitramp()
                    ? "!bg-[#2B2B2B] !text-white"
                    : "!bg-[#fff] !text-[#111b31]"
                }  !font-[600] !mb-0 !rounded-b-[0rem]`}
              >
                Business Info
              </Tab>
              <Tab
                disabled={!canAccessNaturalPerson}
                className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                  isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                } flex justify-center items-center mb-2`}
                selectedClassName={`${
                  isBitramp()
                    ? "!bg-[#2B2B2B] !text-white"
                    : "!bg-[#fff] !text-[#111b31]"
                }  !font-[600] !mb-0 !rounded-b-[0rem]`}
              >
                Individual
              </Tab>
              <Tab
                disabled={!canAccessQuestionary}
                className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                  isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                } flex justify-center items-center mb-2`}
                selectedClassName={`${
                  isBitramp()
                    ? "!bg-[#2B2B2B] !text-white"
                    : "!bg-[#fff] !text-[#111b31]"
                }  !font-[600] !mb-0 !rounded-b-[0rem]`}
              >
                Questionnaire
              </Tab>
              <Tab
                disabled={!canAccessQuestionary}
                className={`py-2 w-full rounded-[0.5rem] cursor-pointer ${
                  isBitramp() ? "bg-[#1F1F1F] text-white" : "bg-[#F6F6F6]"
                } flex justify-center items-center mb-2`}
                selectedClassName={`${
                  isBitramp()
                    ? "!bg-[#2B2B2B] !text-white"
                    : "!bg-[#fff] !text-[#111b31]"
                }  !font-[600] !mb-0 !rounded-b-[0rem]`}
              >
                Bank account and wallet
              </Tab>
            </TabList>

            <TabPanel>{activeTab === 0 && <BusinessInfoFormNEW />}</TabPanel>
            <TabPanel>{activeTab === 1 && <NaturalPersonForm />}</TabPanel>
            <TabPanel>{activeTab === 2 && <QuestionaryForm />}</TabPanel>
            <TabPanel>{activeTab === 3 && <BankCryptoManagement />}</TabPanel>
          </Tabs>
        </div>
      </div>
    </div>
  );
};

export default ClientSettings;
